<template>
  <div class="one-column-view">
    <div class="article-content">
      <div class="row">
        <div class="col-12">
          <h1 class="mb-4">Privacy Policy</h1>
          <p class="fw-bold mb-0">RECENT UPDATE: Oct 3, 2021</p>
          <p class="fw-bold mb-0">Agreement to Access the Site</p>
          <p>
            GoldenLink Plus (“GOLD'') is a business social media platform,
            connecting business and marketers used for various marketing
            purposes, Both Businesses and Marketers provide business and
            demographic data for the purposes of promoting all Business
            activities across the Platform. GOLD is committed to protecting
            privacy and using standard data control business processes to
            protect its members and users.
          </p>

          <p>
            This Privacy Policy explains the data collection and use practices
            of GOLD and all related websites owned or registered to GOLD. It
            does not apply to any third party websites, applications, products
            or services for which GOLD is not responsible.
          </p>
          <p>
            Once you have completed our registration process, you are consenting
            to the information collection and use practices described in this
            policy as well as the Terms of conditions and the site's Business
            Agreement and Gold Striker Agreement. IF YOU DO NOT AGREE WITH THE
            TERMS OF THIS PRIVACY POLICY, THE TERMS OF USE AND OTHER TERMS
            PROVIDED ON THIS SITE, PLEASE DO NOT PROVIDE ANY INFORMATION TO GOLD
            OR USE ANY OF THE SERVICES OR PRODUCTS OFFERED OR PROVIDED ON ANY OF
            THE WEBSITES REFERRED TO IN THIS PRIVACY POLICY.
          </p>

          <p class="color-gold fw-bold mb-0">Changes to Privacy Policy</p>
          <p>
            This Privacy Policy changes from time to time and changes are
            effective upon posting. It is your sole responsibility to
            periodically review this policy for updates and you are solely
            responsible to be aware of any changes to this and all posted
            policies on this website. GOLD does not provide notices of any
            changes in any manner other than by posting the changes at this
            website.
          </p>

          <p class="color-gold fw-bold mb-0">
            The Collection and Use of Information
          </p>
          <p>
            This policy applies to GOLD's collection, use, storage and
            disclosure of information by GOLD on its, (a) websites, including
            all its divisions, subsidiaries and related companies (collectively,
            the "Websites"), (b) on various third party websites, and (c) to
            GOLD's other information collection, including the purchase of
            customer lists from third parties, or the use of customer lists from
            third parties. GOLD is not responsible for the information
            collection or privacy practices of third party websites or
            applications. GOLD is not responsible for any other third party
            sites or applications used by any GS or Business during the pursuit
            of their marketing campaigns, any and all such use will be the sole
            responsibility of that GS or Business.
          </p>

          <p class="color-gold fw-bold mb-0">1. Collection of Information</p>

          <p class="color-gold fw-bold mb-0">1.1. User Direct Information:</p>
          <p>
            As a social media platform, our various members may engage in the
            collection of information as part of their business and campaign
            requirements. In the case where any business or GS Marketer collects
            personal information, we do not direct them or require them to do
            so, but they may as part of their business practices, in this case,
            that Business or GS maintains full responsibility to ensure the
            proper protection and privacy of such collected information.
          </p>

          <p class="color-gold fw-bold mb-0">1.2. Survey Campaign:</p>
          <p>
            GS or Business may collect information from you when you voluntarily
            complete a survey, order form, or a registration page either online
            by using the internet, offline by providing this information through
            the mail, in person or using a telephone, or during any live audio
            event, these activities are all related to various marketing
            campaigns as used by either GS or Business. It is possible this
            information may also be collected by surveys, order forms, or
            registration pages operated by third parties. This method of
            collection is collectively known as a "Survey." In such Surveys, GS
            or Business, may ask you to provide personal identifiable
            information including your name, email address, street address, zip
            code, telephone numbers (including cell phone numbers and carriers),
            birth date, gender, salary range, education and marital status,
            occupation, employment information, personal and online interests,
            and such other information as may be requested from time to time.
            Both Business and GS acknowledge and accept that as part of their
            Social Media activities they are required to follow all Federal and
            State laws regarding the collection, and protection of personally
            identifiable data.
          </p>

          <p class="color-gold fw-bold mb-0">
            1.3 Other Methods of Collecting Personal Information:
          </p>
          <p>
            Other occasions when GS or business obtains information from you
            include (1) your claiming a prize or seeking to redeem an incentive
            offered by business and GS, (2) your requests for assistance through
            GOLD's customer service department.
          </p>

          <p class="color-gold fw-bold mb-0">
            1.5. Cookies, tracking pixels, and Other Info Collected Using
            Technology:
          </p>
          <p>
            GS, Business, or GOLD currently uses cookie and tracking pixel
            technology to associate certain Internet-related information about
            you with information about you in its database. Additionally, GS,
            Business, or GOLD may use other new and evolving sources of
            information in the future. (a) Cookies: "Cookies" are a feature on
            your browser software. If enabled, we may write cookies that may
            store small amounts of data on your computer about your visit to any
            of the pages of this Site. Cookies assist us in tracking which of
            our features appeal the most to you and what content you may have
            viewed on past visits. When you visit this site again, cookies can
            enable us to customize our content according to your preferences. We
            may use cookies to: keep track of the number of return visits to
            this site; accumulate and report aggregate, statistical information
            on website usage; deliver specific content to you based on your
            interests or past viewing history; save your password for ease of
            access to our Site. You can disable cookies, although the Site may
            not function properly for you. Your browser preferences can be
            modified to accept or reject all cookies, or request a notification
            when a cookie is set. You may read more about cookies at
            http://cookiecentral.com. In order to use all of the features and of
            GS, Business, or GOLD's websites, you need to accept cookies. (b)
            tracking pixels: A tracking pixel is a programming code that can be
            used to display an image on a web page, but can also be used to
            transfer your unique user identification to a database and associate
            you with previously acquired information about an individual in a
            database. This allows GS, Business, or GOLD to track certain
            websites you visit. tracking pixels are used to track online
            behavioral habits for marketing purposes to determine products or
            services you may be interested in. In addition to using tracking
            pixels on web pages, GS, Business, or GOLD also uses tracking pixels
            in email messages sent to individuals listed in GS, Business, or
            GOLD's database. (c) IP Addresses: GS, Business, or GOLD
            automatically tracks certain information based upon your behavior on
            the site. We may use this information to do internal research on our
            users' demographics, interests, and behavior to better understand,
            protect and serve you and our community. This information may
            include the website that you just visited, and the next website you
            proceed to visit, your computer browser information, and your IP
            address. Your Internet Protocol ("IP") is a unique Internet
            "address" which is assigned to you by your Internet Service Provider
            ("ISP"). For local area network ("LAN"), DSL, or cable modem users,
            an IP address may be permanently assigned to a particular computer.
            IP addresses are automatically logged by Web servers, collecting
            information about a user's traffic patterns. While the IP address
            does not identify an individual by name, it may, with the
            cooperation of the ISP, be used to locate and identify an individual
            using the Web. Your IP address can, however, reveal what geographic
            area you are connecting from, or which ISP you are using. Finally,
            other websites you visit have IP addresses, and we may collect the
            IP addresses of those websites and their pages. (d) Computer
            Profiles: GS, Business, or GOLD may also collect and accumulate
            other anonymous data which will help us understand and analyze the
            Internet experience of our visitors. For instance, GS, Business, or
            GOLD may accumulate visitor data relating to referring domain names,
            the type of browsers used, operating system software, screen
            resolutions, color capabilities, browser plug-ins, language
            settings, cookie preferences, search engine keywords and JavaScript
            enablement. When you provide us with Personal Identification
            Information, we are able to use such visitor data to identify you.
            (e) Data Mining: Data Mining technology may be employed from time to
            time if used by a Client of GS, Business, or GOLD. (f) New
            Technology: The use of technology on the Internet, including cookies
            and tracking pixels, is rapidly developing. As a result, GS,
            Business, or GOLD strongly encourages individuals to revisit this
            policy for any updates regarding its use of new technology.
          </p>

          <p class="color-gold fw-bold mb-0">
            1.6. No Information Collected from Children:
          </p>
          <p>
            GS, Business, or GOLD will never knowingly collect any personal
            information about children under the age of 18. If GS, Business, or
            GOLD obtains actual knowledge that it has collected personal
            information about a child under the age of 18, that information will
            be immediately deleted from its database. Because it does not
            collect such information, GS, Business, or GOLD has no such
            information to use or to disclose to third parties. GOLD has
            designed this policy in order to comply with the Children's Online
            Privacy Protection Act ("COPPA").
          </p>
          <p>Child Safety Standards-GoldenLink+ GoldenLink+ (goldenlink.io com.goldenlinkplus.play) is committed to maintaining a safe platform for all users. We explicitly prohibit any form of Child Sexual Abuse and Exploitation (CSAE) on our platform. Our standards include: Zero tolerance for child sexual abuse material(CSAM) Immediate removal of any content that violates child safety Cooperation with law enforcement when required In-app reporting mechanism for users to flag inappropriate content Child Safety Point of Contact: support@goldenlinkplus.com (Designated Child Safety Contact for GoldenLink+)</p>

          <p class="color-gold fw-bold mb-0">1.7. Credit Card Information:</p>
          <p>
            Note: The following applies to all users: GOLD does not currently
            collect any credit card information, nor should any GS, or Business,
            attempt to collect Credit card information from you, at any time.
            This is the current GOLD policy.
          </p>

          <p class="color-gold fw-bold mb-0">
            2. Use of Individual Information
          </p>
          <p>
            The following section describes how GS and Business may use personal
            information. The uses described in these sections may change at any
            time. Since GOLD is a social media marketing platform, Business and
            GS may use your individual information for various marketing
            purposes to individuals or entities through, among other things,
            email advertising, telephone marketing, direct mail marketing,
            banners, pop-ups, SMS messaging, events suggestions, push
            notifications, etc, regardless of the method, Business and GS will
            at all times follow all required laws, rules and regulations.
          </p>

          <p class="color-gold fw-bold mb-0">2.1. Email:</p>
          <p>
            As part of the use of GOLDs Social Media platform, you acknowledge
            and agree that from time to time, GOLD may send confirmation emails
            regarding registration or marketing offer set-ups or membership
            verification or certifications or your achievements on the platform,
            including other important announcements.
          </p>
          <p>
            Any marketing related emails will come from either the Business or
            the GS and these emails must adhere to all laws and regulations and
            must also contain the ability to un-subscribe if requested. If you
            wish to end any email message, you only need to press the
            Unsubscribe button on that message.
          </p>
          <p>
            Please select the “unsubscribe” option at the bottom of any GOLD
            email to unsubscribe, you understand you will not receive any of the
            social media events and activities related to your account,
            including events that may be of great benefit to you.
          </p>

          <p class="color-gold fw-bold mb-0">
            2.2. Profiling and Target Advertising:
          </p>
          <p>
            GOLD may use your information to make and improve profiles of you
            and to track your online browsing habits and determine which areas
            of GOLD's websites are most frequently visited. This information
            helps GOLD to better understand your interests so that it can target
            advertising and promotions to you. GOLD may, at its discretion,
            target advertising by using email, direct mail, telephones, cell
            phones, and other means of communication to provide promotional
            offers. All marketing campaigns (including Live Audio Events) and
            surveys, must adhere to all Federal and State Privacy Laws.
          </p>

          <p class="color-gold fw-bold mb-0">
            2.3. Storage of Personal Information:
          </p>
          <p>
            GOLD stores your information in a database on GOLD's servers. Our
            servers have security measures (such as a firewall) in place to
            protect against the loss, misuse, and alteration of the information
            under GOLD's control. Notwithstanding such measures, GOLD cannot
            guarantee that its security measures will prevent GOLD computers
            from being illegally accessed, and your information from being
            stolen or altered.
          </p>

          <p class="color-gold fw-bold mb-0">3. Use of Personal Information</p>

          <p class="color-gold fw-bold mb-0">
            3.1. Sale or Transfer to Third Parties:
          </p>
          <p>
            Gold will not sell or rent your information to any other party at
            any time for any reason … period.
          </p>
          <p>
            Upon accepting our Terms and Conditions, you acknowledge and agree,
            that regardless of all safeguards and policies that GoldenLink has
            in place, the ultimate responsibility for protection of your
            personal and private information rests with YOU, the user of the
            platform.
          </p>
          <p>
            Any Business or Marketer on the Gold platform, agrees to follow all
            stated privacy policies contained within this Privacy Policy as well
            as the Terms and Conditions. Click here to review the Terms and
            Conditions.
          </p>
          <p>
            If any user does not follow the Privacy policy they have agreed to
            within this Privacy Policy then that user will be in violation and
            subject to removal from the platform and other legal actions at
            Gold’s sole discretion
          </p>
          <p>
            At no time is any Business or Marketer to sell or rent the private
            personal information of any user on the platform.
          </p>

          <p class="color-gold fw-bold mb-0">3.2. Customer Service:</p>
          <p>
            GOLD will use your personal information to respond to you, to
            process, validate and verify requests and/or purchase orders, to
            fulfill any of your requests and to tailor your experience on our
            websites.
          </p>

          <p class="color-gold fw-bold mb-0">3.3. Marketing:</p>
          <p>
            GOLD will only use your personal information for marketing and
            survey purposes on behalf of GOLD and its affiliates and
            subsidiaries. GOLD will only allow disclosure of your personal
            information to third party agents, independent contractors, or any
            other entities only upon your approval, with the exception of
            section 3.4 below.
          </p>

          <p class="color-gold fw-bold mb-0">
            3.4. Complying with Legal Process:
          </p>
          <p>
            GOLD will use or disclose your personal information in response to
            subpoenas, court orders, warrants, or legal process, or to otherwise
            establish or exercise our legal rights or defend against legal
            claims or in the event you violate or breach an agreement with GOLD.
            GOLD will use and disclose your personal information if we believe
            you will harm the property or rights of GOLD, its owners, or those
            of GOLD's other customers. Finally, we will use or disclose your
            personal information if we believe it is necessary to share
            information in order to investigate, prevent, or take action
            regarding illegal activities, suspected fraud, situations involving
            potential threats to the physical safety of any person, violations
            of GOLD's acceptable use policy, or as otherwise required by law
            when responding to subpoenas, court orders and other legal
            processes.
          </p>

          <p class="color-gold fw-bold mb-0">3.5. Order Fulfillment:</p>
          <p>
            GOLD will transfer your personal information to third parties when
            necessary to provide a product or service that you order from such a
            third party while using GOLD's websites or when responding to offers
            provided by GOLD.
          </p>

          <p class="color-gold fw-bold mb-0">3.6. Data Summary:</p>
          <p>
            GOLD may sell or transfer non-individualized information, such as
            summary or aggregated anonymous information about all persons or
            sub-groups of persons.
          </p>

          <p class="color-gold fw-bold mb-0">
            3.7. Other Access to Personal Information:
          </p>
          <p>
            You have access to your personal information submitted when
            registering for Gold services. You may log in to update such
            information.
          </p>

          <p class="color-gold fw-bold mb-0">
            4. Privacy Practices of Third Parties
          </p>

          <p class="color-gold fw-bold mb-0">
            4.1. Advertiser cookies and tracking pixels:
          </p>
          <p>
            Advertising agencies, advertising networks, and other companies who
            place advertisements on the websites and on the internet generally
            may use their own cookies, tracking pixels, and other technology to
            collect information about individuals. GOLD does not control the use
            of such technology and GOLD has no responsibility for the use of
            such technology to gather information about you.
          </p>

          <p class="color-gold fw-bold mb-0">4.2. Links:</p>
          <p>
            The websites and email messages sometimes contain hypertext links to
            the websites of third parties. GOLD is not responsible for the
            privacy practices or the content of such other websites. Linked
            websites may contain links to websites maintained by third parties.
            Such links are provided for your convenience and reference only.
            GOLD does not operate or control in any respect any information,
            software, products or services available on such third party
            websites. The inclusion of a link to a website does not imply any
            endorsement of the services or the site, its contents, or its
            sponsoring organization.
          </p>

          <p class="color-gold fw-bold mb-0">5. Unsubscribe Procedures</p>
          <p class="mb-0">
            If you wish to discontinue receiving email messages from GOLD, you
            may:
          </p>
          <ol type="a">
            <li>
              Unsubscribe from the email sent to you by pressing the
              "Unsubscribe" button..
            </li>
            <li>
              Unsubscribe by sending an email to support@goldenlinkplus.com.
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
